// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"1ca93b8e","563":"92adad7b"}[chunkId] + ".chunk.js";
};